import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import categoryApi from "../api/blog/categoryApi";
import blogApi from "../api/blog/blogApi";

// create slice
const name = "blog";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const blogActions = { ...slice.actions, ...extraActions };
export const blogReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstCategory: [],
    totalCount: 0,
    lstBlog: [],
    totalCountBlog: 0,
  };
}

function createExtraActions() {
  return {
    getCategories: getCategories(),
    getBlogs: getBlogs(),

  };

  function getCategories() {
    return createAsyncThunk(
      `${name}/getCategories`,
      async (params) => await categoryApi.getCategories(params)
    );
  }

  function getBlogs() {
    return createAsyncThunk(
      `${name}/getBlogs`,
      async (params) => await blogApi.getBlogs(params)
    );
  }
}

function createExtraReducers() {
  return {
    ...getCategories(),
    ...getBlogs(),

  };

  function getCategories() {
    const { pending, fulfilled, rejected } = extraActions.getCategories;
    return {
      [pending]: (state) => {
        state.lstCategory = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstCategory = data.results;
        state.totalCount = data.totalResults;
      },
      [rejected]: (state, action) => {
        state.lstCategory = [];
      },
    };
  }

  function getBlogs() {
    const { pending, fulfilled, rejected } = extraActions.getBlogs;
    return {
      [pending]: (state) => {
        state.lstBlog = [];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstBlog = data.results;
        state.totalCountBlog = data.totalResults;

      },
      [rejected]: (state, action) => {
        state.lstBlog = [];
      },
    };
  }

}
